<template>
  <div class="pa-4">
    <div class="d-flex align-center mb-4">
      <h2 class="text-h5 font-weight-bold">Aprobări Manager</h2>
      <v-chip class="ml-3" color="red-darken-1" variant="tonal" v-if="totalPending > 0">
        {{ totalPending }} în așteptare
      </v-chip>
      <v-spacer />
      <v-btn icon="mdi-refresh" variant="text" @click="incarca" :loading="loading" />
    </div>

    <v-tabs v-model="tab" color="red-darken-1" class="mb-4">
      <v-tab value="concedii">Concedii ({{ concedii.length }})</v-tab>
      <v-tab value="documente">Documente ({{ documente.length }})</v-tab>
    </v-tabs>

    <v-window v-model="tab">
      <!-- Concedii -->
      <v-window-item value="concedii">
        <v-card v-for="c in concedii" :key="c.ID" elevation="1" class="mb-3" rounded="lg">
          <v-card-text>
            <div class="d-flex align-center">
              <div>
                <div class="font-weight-bold">{{ c.NumeAngajat }}</div>
                <div class="text-caption text-medium-emphasis">
                  {{ formatDate(c.DataInceput) }} — {{ formatDate(c.DataSfarsit) }} · {{ c.NumarZile }} zile · {{ c.TipConcediu }}
                </div>
                <div v-if="c.Descriere" class="text-body-2 mt-1">{{ c.Descriere }}</div>
              </div>
              <v-spacer />
              <v-btn color="green" variant="tonal" size="small" class="mr-2" @click="actiune(c.ID, 'concediu', true)">
                <v-icon>mdi-check</v-icon> Aprobă
              </v-btn>
              <v-btn color="red" variant="tonal" size="small" @click="actiune(c.ID, 'concediu', false)">
                <v-icon>mdi-close</v-icon> Respinge
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
        <v-alert v-if="!loading && concedii.length === 0" type="info" variant="tonal">Nu există cereri de concediu în așteptare.</v-alert>
      </v-window-item>

      <!-- Documente -->
      <v-window-item value="documente">
        <v-card v-for="d in documente" :key="d.ID" elevation="1" class="mb-3" rounded="lg">
          <v-card-text>
            <div class="d-flex align-center">
              <div>
                <div class="font-weight-bold">{{ d.NumeAngajat }}</div>
                <div class="text-caption text-medium-emphasis">{{ d.TipDenumire }}</div>
                <div v-if="d.Descriere" class="text-body-2 mt-1">{{ d.Descriere }}</div>
              </div>
              <v-spacer />
              <v-btn color="green" variant="tonal" size="small" class="mr-2" @click="actiune(d.ID, 'document', true)">
                <v-icon>mdi-check</v-icon> Aprobă
              </v-btn>
              <v-btn color="red" variant="tonal" size="small" @click="actiune(d.ID, 'document', false)">
                <v-icon>mdi-close</v-icon> Respinge
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
        <v-alert v-if="!loading && documente.length === 0" type="info" variant="tonal">Nu există cereri de documente în așteptare.</v-alert>
      </v-window-item>
    </v-window>

    <!-- Dialog observație -->
    <v-dialog v-model="dialogObs" max-width="420" persistent>
      <v-card rounded="xl">
        <v-card-title class="pa-4">{{ actiunePendinga?.aprobare ? 'Aprobare' : 'Respingere' }}</v-card-title>
        <v-divider />
        <v-card-text class="pa-4">
          <v-textarea v-model="observatie" label="Observație (opțional)" variant="outlined" density="compact" rows="3" />
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-btn variant="text" @click="dialogObs = false">Anulează</v-btn>
          <v-spacer />
          <v-btn :color="actiunePendinga?.aprobare ? 'green' : 'red'" :loading="actLoading" @click="confirmActiune">Confirmă</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import PORTAL_Aprobari from '@/services/Portal/PORTAL_Aprobari'

export default defineComponent({
  name: 'AprobariManager',
  data() {
    return {
      loading: false, actLoading: false,
      tab: 'concedii',
      concedii: [] as any[],
      documente: [] as any[],
      dialogObs: false,
      observatie: '',
      actiunePendinga: null as { id: string; tip: string; aprobare: boolean } | null
    }
  },
  computed: {
    totalPending(): number { return this.concedii.length + this.documente.length; }
  },
  mounted() { this.incarca(); },
  methods: {
    async incarca() {
      this.loading = true;
      try {
        const resp = await PORTAL_Aprobari.getPending();
        this.concedii = resp.data?.Concedii ?? [];
        this.documente = resp.data?.Documente ?? [];
      } finally {
        this.loading = false;
      }
    },
    actiune(id: string, tip: string, aprobare: boolean) {
      this.actiunePendinga = { id, tip, aprobare };
      this.observatie = '';
      this.dialogObs = true;
    },
    async confirmActiune() {
      if (!this.actiunePendinga) return;
      this.actLoading = true;
      try {
        const { id, tip, aprobare } = this.actiunePendinga;
        if (aprobare) await PORTAL_Aprobari.aprobare(id, tip, this.observatie);
        else await PORTAL_Aprobari.respingere(id, tip, this.observatie);
        this.dialogObs = false;
        await this.incarca();
      } finally {
        this.actLoading = false;
      }
    },
    formatDate(d: string): string {
      if (!d) return '';
      return new Date(d).toLocaleDateString('ro-RO');
    }
  }
})
</script>
